// extracted by mini-css-extract-plugin
export default {"modalOverlay":"XD-z","modalContent":"YD-z","header":"ZD-z","close":"_D-z"};